// Formats cents in the currency carried on the element, so past orders keep the currency they
// were placed in. Liquid's `money` filter and `priceformat.liquid` can't: both key off the
// session currency.
//
// Keep the element empty. The section loads this script before the elements parse, so
// connectedCallback runs childless and any inner text would land *after* the output.
class MoneyFormat extends HTMLElement {
  connectedCallback() {
    const { amount, currency } = this.dataset;
    if (!currency || amount === undefined || amount === '') return;

    try {
      this.textContent = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
      }).format(Number(amount) / 100);
    } catch (err) {
      console.warn('[MoneyFormat] Could not format', amount, currency, err);
    }
  }
}
if (!customElements.get('money-format')) customElements.define('money-format', MoneyFormat);
